import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    Container, Modal, Header, Button, Segment, Icon, Table
} from 'semantic-ui-react';
import { actions } from '../_orders/sagaSlice';
import useLoader from '+/hooks/useLoader';
import Dimmer from '+/Dimmer';


const UnitOrders = props => {

    const {
        readAllByUnit, orders, isFetching, match
    } = props;
    const { property_id, unit_id } = match.params;
    const [modalOpen, setModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState(null);
    const showLoader = useLoader();

    useEffect(() => {
        readAllByUnit({
            property_id,
            unit_id
        });
    }, [property_id, readAllByUnit, unit_id]);

    const Placeholder = () => (
        <Segment placeholder>
            <Header icon>
                <Icon name='file alternate outline' />
            No orders are listed for this unit.
            </Header>
            <Button
                compact
                primary
                icon='add'
                content='New Order'
                onClick={() => setModalOpen(true)}
            />
        </Segment>
    );

    if (isFetching || showLoader) {
        return <Dimmer />;
    }

    return (
        <Container>
            <div className='title-with-button'>
                <Header
                    as='h3'
                    content='Orders'
                    color='grey'
                />
                <Modal
                    open={modalOpen}
                    size='tiny'>
                    <Modal.Header>
                        {`${initialValues ? 'Edit' : 'New'} Order`}
                    </Modal.Header>
                    <Modal.Content>
                        {/* <Form
                            setModalOpen={setModalOpen}
                            propertyId={propertyId}
                            unitId={unit_id}
                            initialValues={initialValues}
                        /> */}
                    </Modal.Content>
                </Modal>
                { !!orders.length && <Button
                    compact
                    primary
                    icon='add'
                    content='New Order'
                    onClick={() => {
                        setInitialValues(null);
                        setModalOpen(true);
                    }}
                /> }
            </div>

            {!isFetching && !orders.length && <Placeholder />}


            <Table>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Type</Table.HeaderCell>
                        <Table.HeaderCell>Notes</Table.HeaderCell>
                        <Table.HeaderCell>Admin Notes</Table.HeaderCell>
                        <Table.HeaderCell textAlign='right'>Actions</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        orders.map((order, i) => (
                            <Table.Row key={i}>
                                <Table.Cell>
                                    {order.type}
                                </Table.Cell>
                                <Table.Cell>
                                    {order.notes}
                                </Table.Cell>
                                <Table.Cell>
                                    {order.admin_notes}
                                </Table.Cell>
                                <Table.Cell textAlign='right'>
                                    <Button.Group>
                                        <Button
                                            compact
                                            size='small'
                                            content='Edit'
                                            icon='edit'
                                            onClick={() => {
                                                setInitialValues(order);
                                                setModalOpen(true);
                                            }}
                                        />
                                        <Button
                                            compact
                                            size='small'
                                            negative
                                            content='Delete'
                                            icon='delete'
                                            // onClick={handleDelete(user.id)}
                                        />
                                    </Button.Group>
                                </Table.Cell>
                            </Table.Row>
                        ))
                    }
                </Table.Body>

            </Table>


        </Container>
    );
};

const mapStateToProps = state => ({
    orders: Object.values(state.orders.data),
    isFetching: state.orders.isFetching
});

export default connect(mapStateToProps, actions)(UnitOrders);

